module.exports = __webpack_public_path__ + "img/m-banner-fmugwkfb-fr-FR.530f98cd.png";